<template>

<!-- Modal -->
<div class="modal modal-mask" id="modalSpinner" style="display: block" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">
          <i class="fas fa-bullhorn mr-2" aria-hidden="true"></i> 
          <strong>{{props.title}}</strong></h5>
       
      </div>
      <div class="modal-body">

        <div v-if="props.spinner" class="text-center">

            <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            
        </div>
        <div v-else>
              <h4 style="color:blue" class="text-center"> 
                   <!--<i style="color:red;" class="fas fa-exclamation-triangle mr-3" aria-hidden="true"></i>-->
                  <strong>{{props.msg}} </strong></h4>
        </div>        
        
      </div>
      <div class="modal-footer">
        <div v-if="props.btn != 'Retry'">
            <button v-if="!props.spinner" type="button" @click="$emit('close')" class="btn btn-primary" >CHIUDI</button>
        </div>
        <div v-else>
            <button v-if="!props.spinner" type="button" @click="$emit('close','Retry')" class="btn btn-primary" >CHIUDI E RIPROVA</button>
        </div>

        
      </div>
    </div>
  </div>
</div>




</template>
<script>
export default {
  props: ['props'],
  data () 
  {
    return {

        
    }
    
    },
  computed : {
     
  },
   created () 
    {
      
      
    },
  methods: {
   
   
  }
}
</script>

<style scoped>
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 3px navy solid  !important;

}
/*
.modal-footer {  
  justify-content: space-between;  
}
*/
h4 {
  font-family   : 'Roboto Condensed';
  font-size     : 20px;
}
h5 {
  font-family   : 'Roboto Condensed';
  font-size     : 20px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
  
}
</style>
